import { useNavigate, useSearchParams } from 'react-router';
import { useAuth } from '../auth/AuthProvider.js';
import { Button } from '../components/Button.js';
import { Layout } from '../components/Layout.js';
import { es } from '../i18n/es.js';

export function NotInvitedPage() {
  const [params] = useSearchParams();
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const disabled = params.get('reason') === 'disabled';

  const tryAnother = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  return (
    <Layout center>
      <section className="flex flex-col gap-6">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-accent">
          {es.appName}
        </p>
        <div className="flex flex-col gap-3">
          <h1 className="text-3xl font-semibold leading-tight tracking-tight">
            {disabled ? es.notInvited.disabledTitle : es.notInvited.title}
          </h1>
          <p className="text-base leading-relaxed text-neutral-600 dark:text-neutral-400">
            {disabled ? es.notInvited.disabledBody : es.notInvited.body(user?.email ?? null)}
          </p>
        </div>
        <Button variant="secondary" onClick={() => void tryAnother()} className="self-start">
          {es.notInvited.tryAnother}
        </Button>
      </section>
    </Layout>
  );
}
